import PropTypes from 'prop-types'

import Text from '/src/components/@common.blocks/Text'

const FormField = ({ title, icon, required, children }) => {
  const fieldClassName =
    'form-field' + (required === true ? ' form-field--required' : '')

  return (
    <div className={fieldClassName}>
      {title && (
        <div className='form-field__header'>
          {icon || ''}
          <Text className='form-field__label' size='md' weight='semi-bold'>
            {title}
          </Text>
        </div>
      )}
      {children}
    </div>
  )
}

FormField.defaultProps = {
  required: false,
}

FormField.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.any,
  children: PropTypes.node.isRequired,
}

export default FormField
